import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import RecosQuickViewModal from 'components/outfitRecos/RecosQuickViewModal';
import RecosQuickViewModalV2 from 'components/outfitRecos/RecosQuickViewModalV2';
import { ProductStyle } from 'types/cloudCatalog';
import RecosCardV3 from 'components/outfitRecos/RecosCardV3';
import { OUTFIT_QUICK_VIEW_MODAL_TREATMENT } from 'constants/outfitRecos';
import { fetchComplementaryRecos } from 'actions/outfitRecos';
import { selectOutfitRecos } from 'selectors/outfitRecos';
import { generateOutfitGroup } from 'helpers/outfitRecoUtils';
import { track } from 'apis/amethyst';
import { evOutfitRecoCardView } from 'events/outfitRecos';

import css from 'styles/components/outfitRecos/recosSection.scss';

interface RecosSectionProps {
  currentStyle: ProductStyle;
  hydraAssignment: number;
  isModalOpen?: boolean;
}

export const RecosSection = ({ currentStyle, hydraAssignment, isModalOpen = false }: RecosSectionProps) => {
  const [isQuickViewModalOpen, setIsQuickViewModalOpen] = useState<boolean>(isModalOpen);
  const [contentIndex, setContentIndex] = useState<number>(0);
  const [initialStyleId, setInitialStyleId] = useState<string>();

  const dispatch = useDispatch();

  const { outfitRecosContent } = useSelector(selectOutfitRecos);

  useEffect(() => {
    dispatch(fetchComplementaryRecos(currentStyle.styleId));
  }, [currentStyle.styleId]);

  useEffect(() => {
    if (outfitRecosContent.length && currentStyle) {
      const outfitGroups = outfitRecosContent.map(content => {
        const { productList, complementaryGroupId } = content;
        return generateOutfitGroup(complementaryGroupId, productList);
      });
      track(() => [evOutfitRecoCardView, { seedStyleId: currentStyle.styleId, outfitGroups }]);
    }
  }, [outfitRecosContent.length, currentStyle]);

  if (outfitRecosContent.length === 0) {
    return null;
  }

  const closeQuickViewModal = () => {
    setInitialStyleId(undefined);
    setIsQuickViewModalOpen(false);
  };

  const makeQuickViewModal = () =>
    hydraAssignment === OUTFIT_QUICK_VIEW_MODAL_TREATMENT ? (
      <RecosQuickViewModal
        closeModal={closeQuickViewModal}
        outfitRecoContent={outfitRecosContent[contentIndex]!}
        initialStyleId={initialStyleId}
        currentStyle={currentStyle}
      />
    ) : (
      <RecosQuickViewModalV2 closeModal={closeQuickViewModal} outfitRecoContent={outfitRecosContent[contentIndex]!} currentStyle={currentStyle} />
    );

  return (
    <div className={css.sectionWrapper}>
      <h2 className={css.heading}>Styling Ideas</h2>
      <RecosCardV3
        contents={outfitRecosContent}
        contentIndex={contentIndex}
        setContentIndex={setContentIndex}
        setInitialStyleId={setInitialStyleId}
        setIsQuickViewModalOpen={setIsQuickViewModalOpen}
      />
      {isQuickViewModalOpen && makeQuickViewModal()}
    </div>
  );
};

export default RecosSection;
